import { LucideIcon } from "lucide-react";

export default function EmptyState({
  icon: Icon,
  title,
  message,
  small = false,
}: {
  icon: LucideIcon;
  title: string;
  message: string;
  small?: boolean;
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center ${
        small ? "h-sm" : "h-[60vh]"
      } w-full max-w-5xl mx-auto`}
    >
      <Icon
        className={`${small ? "w-8 h-8" : "w-16 h-16"} text-gray-300 mb-4`}
      />
      <h2
        className={`${
          small ? "text-xl" : "text-2xl"
        } font-semibold text-gray-400 mb-2`}
      >
        {title}
      </h2>
      <p className="text-gray-500 text-center max-w-md">{message}</p>
    </div>
  );
}
